// External dependencies
import { __ } from "@wordpress/i18n";
import { registerBlockType } from "@wordpress/blocks";
import { Fragment } from "@wordpress/element";
import { MediaPlaceholder, RichText, BlockControls, MediaReplaceFlow } from "@wordpress/block-editor";

// Internal dependencies
import ResourceBody from "../components/Resources/ResourcesBody";

// Block attributes (custom props)
const attributes = {
    headline: {
        type: 'string',
        default: "Summary"
    },
    takeaways: {
        type: 'string',
        default: ""
    },
    actions: {
        type: 'string',
        default: ""
    },
    // accordion: {
    //     type: 'array',
    //     default: [{
    //         heading: 'Key takeaways',
    //         question: 'What is the outcome you’re hoping for?',
    //         answer: 'The outcome is a positive impact on the community and the economy.',
    //     }, {
    //         heading: 'Key actions',
    //         question: 'What is the outcome you’re hoping for?',
    //         answer: 'The outcome is a positive impact on the community and the economy.',
    //     }]
    // }
}

const allowedFormats = [
    'core/bold',
    'core/italic',
    // 'core/image',
    'core/strikethrough',
    'core/link',
    'core/subscript',
    'core/superscript',
    'core/underline',
    // 'core/code',
    // 'core/quote',
    // 'core/list',
    // 'core/ordered-list',
    // 'core/unordered-list',
];

// Edit function (responsible for wp-admin post edit screen)
const edit = ({ setAttributes, attributes }) => {
    const { headline, takeaways, actions } = attributes;

    return (
        <Fragment>
            <ResourceBody
                style={{ width: '100%', marginLeft: 0 }}
                headline={
                    <RichText
                        value={headline}
                        multiline={false}
                        onChange={(headline) => setAttributes({ headline })}
                        placeholder={__('Summary', 'hero')}
                        allowedFormats={[]}
                        keepPlaceholderOnFocus={true}
                    />}
                takeaways={<RichText
                    value={takeaways}
                    multiline={false}
                    onChange={(takeaways) => setAttributes({ takeaways })}
                    placeholder={__("Key takeaways", 'hero')}
                    allowedFormats={allowedFormats}
                    keepPlaceholderOnFocus={true}
                />}
                actions={<RichText
                    value={actions}
                    multiline={false}
                    onChange={(actions) => setAttributes({ actions })}
                    placeholder={__("Key actions", 'hero')}
                    allowedFormats={allowedFormats}
                    keepPlaceholderOnFocus={true}
                />}
            />
        </Fragment>
    );
}

// Save function (responsible for static HTML saved in database)
const save = ({ attributes }) => {
    // const { headline, accordion = [] } = attributes;
    return (
        <div className="gutenberg-resource-body" data-mt-attributes={encodeURIComponent(JSON.stringify(attributes))} />
    );
}

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/#registering-a-block
 */
registerBlockType("mt/gutenberg-resource-body", {

    /**
     * This is the display title for your block, which can be translated with `i18n` functions.
     * The block inserter will show this name.
     */
    title: __("Resource Body", "gutenberg-resource-body"),

    /**
     * An icon property should be specified to make it easier to identify a block.
     * These can be any of WordPress’ Dashicons, or a custom svg element.
     */
    icon: "align-wide",

    /**
     * Blocks are grouped into categories to help users browse and discover them.
     * The categories provided by core are `common`, `embed`, `formatting`, `layout` and `widgets`.
     */
    category: "widgets",

    /**
     * Optional block extended support features.
     */
    // supports: {
    //     // Removes support for an HTML mode.
    //     html: false
    // },
    attributes,

    /**
     * The edit function describes the structure of your block in the context of the editor.
     * This represents what the editor will render when the block is used.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#edit
     *
     * @param {Object} [props] Properties passed from the editor.
     *
     * @return {WPElement} Element to render.
     */
    edit,

    /**
     * The save function defines the way in which the different attributes should be combined
     * into the final markup, which is then serialized by the block editor into `post_content`.
     *
     * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
     *
     * @return {WPElement} Element to render.
     */
    save
});
